import {
    ClientPreviewFieldsFragment,
    ClinicFieldsFragment,
    PatientPreviewFieldsFragment,
} from '~graphql/generated/graphql'

export type OnSelectArgs = {
    client?: ClientPreviewFieldsFragment | null | undefined
    patient?: PatientPreviewFieldsFragment | null | undefined
    clinic?: ClinicFieldsFragment | null | undefined
}

export enum SearchModalType {
    Client = 'client',
    Patient = 'patient',
}
